'use strict';

const User = require('../models/User');
const FavoriteModel = require('bunsen/models/identity/Favorite');

// Actions
const favoritesActions = require('./favoritesActions');

// Store
const FavoritePageStore = require('../stores/FavoritePageStore');

const favoritePageActions = {

    fetchFavoritePage(actionContext, payload, done) {
        const {resetCollection = false, type, page, solrQuery} = payload;
        const store = actionContext.getStore(FavoritePageStore);
        const collection = store.getCollection();

        if (store.isLoading(type)) {
            done();
        } else {
            collection.setParam('userIds', User.getUserId());
            collection.setParam('queries', solrQuery);
            collection.setParam('types', type);

            if (type === FavoriteModel.TYPE_SEARCH) {
                collection.setParam('queries', solrQuery);
                collection.setParam('pages', null);
            } else {
                collection.setParam('pages', page);
            }

            actionContext.dispatch('favoritePage:fetch:start', {type});

            collection
                .fetchWithParameters({reset: resetCollection, remove: false})
                .always(() => {
                    const model = collection.last();
                    actionContext.dispatch('favoritePage:fetch:end', {type});
                    actionContext.dispatch('favorites:favorite:add', model);
                    done();
                });
        }
    },

    saveToFavorites(actionContext, payload, done) {
        const {type, page} = payload;

        actionContext
            .executeAction(favoritesActions.saveToFavorites, payload)
            .then((model) => {
                actionContext.dispatch('favorites:favorite:add', model);
                done();
            })
            .catch(error => {
                // Already favorited
                if (error && error.status === 409) {
                    actionContext.executeAction(favoritePageActions.fetchFavoritePage, {type, page}, done);
                } else {
                    actionContext.dispatch('favoritePage:error', error);
                    done(error);
                }
            });
    },

    removeFromFavorites(actionContext, payload, done) {
        actionContext
            .executeAction(favoritesActions.removeFromFavorites, payload)
            .then((model) => {
                actionContext.dispatch('favorites:favorite:remove', model);
                done();
            })
            .catch(error => {
                actionContext.dispatch('favoritePage:error', error);
                done();
            });
    }

};

module.exports = favoritePageActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/favoritePageActions.es.js